import { IAutomationAppComponent } from "../../types";
import {
    schema,
    schemaTemperature,
    schemaFlowTemperature,
    schemaHumidity,
    schemaOutletTemperature,
    schemaPressure,
    schemaTemperature1,
    schemaTemperature2,
    schemaTemperature3,
    schemaTemperature4,
    schemaTemperature5,
    schemaTemperature6
} from "./types";
import { OverviewPanel, OperatorPanel, ConfigurationPanel } from '.';
import { WiBarometer, WiHumidity, WiThermometer } from "react-icons/wi";
import {SideviewPanel} from "./SideviewPanel";


export const App: IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: null,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Analog Sensor",
        description: "Analog sensor",
        panel: OverviewPanel,
        defaultState: { value: 10.1, dimension: '#' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}

export const AppTemp: IAutomationAppComponent = {
    schema: schemaTemperature,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Temperature sensor",
        description: "Temperature sensor",
        panel: OverviewPanel,
        defaultState: { value: 23.1, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: -20.0 },
            { key: 'RangeMax', value: 80.0 },
        ]
    },
}

export const AppTemp1: IAutomationAppComponent = {
    schema: schemaTemperature1,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "First Temperature sensor in a system",
        description: "Puffer Temperature sensor 1 (topmost)",
        panel: OverviewPanel,
        defaultState: { value: 1, dimension: '' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}

export const AppTemp2: IAutomationAppComponent = {
    schema: schemaTemperature2,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Second Temperature sensor in a system",
        description: "Puffer Temperature sensor 2",
        panel: OverviewPanel,
        defaultState: { value: 2, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}


export const AppTemp3: IAutomationAppComponent = {
    schema: schemaTemperature3,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Third Temperature sensor in a system",
        description: "Puffer Temperature sensor 3",
        panel: OverviewPanel,
        defaultState: { value: 3, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}

export const AppTemp4: IAutomationAppComponent = {
    schema: schemaTemperature4,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Fourth Temperature sensor in a system",
        description: "Puffer Temperature sensor 4",
        panel: OverviewPanel,
        defaultState: { value: 4, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}

export const AppTemp5: IAutomationAppComponent = {
    schema: schemaTemperature5,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Fifth Temperature sensor in a system",
        description: "Puffer Temperature sensor 5",
        panel: OverviewPanel,
        defaultState: { value: 5, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}


export const AppTemp6: IAutomationAppComponent = {
    schema: schemaTemperature6,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Sixth Temperature sensor in a system",
        description: "Temperature sensor 6",
        panel: OverviewPanel,
        defaultState: { value: 6.0, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}
export const AppHum: IAutomationAppComponent = {
    schema: schemaHumidity,
    supportsProcessPanel: false,
    Icon: WiHumidity,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Humidity sensor",
        description: "Humidity sensor",
        panel: OverviewPanel,
        defaultState: { value: 45.0, dimension: '%' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 100.0 },
        ]
    },
}
export const AppPress: IAutomationAppComponent = {
    schema: schemaPressure,
    supportsProcessPanel: false,
    Icon: WiBarometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Pressure sensor",
        description: "Pressure sensor",
        panel: OverviewPanel,
        defaultState: { value: 250.0, dimension: 'pa' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 500.0 },
        ]
    },
}

export const AppTempOutlet: IAutomationAppComponent = {
    schema: schemaOutletTemperature,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Outlet temperature sensor (Air Handling Unit)",
        description: "Outlet temperature sensor",
        panel: OverviewPanel,
        defaultState: { value: 19.7, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 80.0 },
        ]
    },
}

export const AppTempFlow: IAutomationAppComponent = {
    schema: schemaFlowTemperature,
    supportsProcessPanel: false,
    Icon: WiThermometer,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    SideViewPanel: SideviewPanel,
    createConfig: {
        group: 'AnalogSensors',
        name: "Flow temperature sensor (Air Handling Unit)",
        description: "Flow temperature sensor",
        panel: OverviewPanel,
        defaultState: { value: 21.7, dimension: '°C' },
        defaultProperties: [
            { key: 'Dimension', value: '' },
            { key: 'Value', value: 0.0 },
            { key: 'RangeMin', value: 0.0 },
            { key: 'RangeMax', value: 80.0 },
        ]
    },
}


